<template>
  <div class="container-fluid">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div class="admin-page-content user-crud">
      <div class="internal-container">
        <div class="stepwizard">
          <div class="stepwizard-row setup-panel">
            <div class="stepwizard-step">
              <a href="#step-1" type="button" class="btn btn-primary btn-circle" id="step1">1</a>
              <p>Claim</p>
            </div>
            <div class="stepwizard-step">
              <a href="#step-2" type="button" class="btn btn-tertiary btn-circle" disabled="disabled" id="step2">2</a>
              <p>Failure</p>
            </div>
            <div class="stepwizard-step">
              <a href="#step-3" type="button" class="btn btn-tertiary btn-circle" id="step3" disabled="disabled">3</a>
              <p>Parts</p>
            </div>
            <div class="stepwizard-step">
              <a href="#step-4" type="button" class="btn btn-tertiary btn-circle" id="step4" disabled="disabled">4</a>
              <p>{{ labor_spelling }}</p>
            </div>
            <div class="stepwizard-step">
              <a href="#step-5" type="button" class="btn btn-tertiary btn-circle" id="step5" disabled="disabled">5</a>
              <p>Other Charges</p>
            </div>
            <div class="stepwizard-step">
              <a href="#step-6" type="button" class="btn btn-tertiary btn-circle" id="step6" disabled="disabled">6</a>
              <p>RMA</p>
            </div>
            <div class="stepwizard-step">
              <a href="#step-7" type="button" class="btn btn-tertiary btn-circle" id="step7" disabled="disabled">7</a>
              <p>Payment</p>
            </div>
            <div class="stepwizard-step">
              <a href="#step-8" type="button" class="btn btn-tertiary btn-circle" id="step8" disabled="disabled">8</a>
              <p>Attachments</p>
            </div>
            <div class="stepwizard-step">
              <a href="#step-9" type="button" class="btn btn-tertiary btn-circle" id="step9" disabled="disabled">9</a>
              <p>Review</p>
            </div>
          </div>
        </div>


        <form method="posts" class="form-horizontal basic-form-container add-user-form-title form-custom-select"
          id="userform">
          <claim-tab ref="claimTab" @send-claim-data-to-parent="handleClaimTabData"></claim-tab>
          <failure-tab ref="failureTab" @send-failure-data-to-parent="handleFailureTabData"></failure-tab>
          <part-tab ref="partTab" @send-part-data-to-parent="handlePartTabData"></part-tab>
          <labor-tab ref="laborTab" @send-labor-data-to-parent="handleLaborTabData"></labor-tab>
          <other-charge-tab ref="otherChargeTab"
            @send-other-charges-data-to-parent="handleOtherChargesTabData"></other-charge-tab>
          <location-tab ref="locationTab" @send-location-data-to-parent="handleLocationTabData"></location-tab>
          <payment-tab ref="paymentTab" @send-payment-data-to-parent="handlePaymentTabData"></payment-tab>
          <attachment-tab ref="attachmentTab" @send-attachment-data-to-parent="handleAttachmentTabData"></attachment-tab>
          <review-tab ref="reviewTab" @send-review-data-to-parent="handleReviewTabData"></review-tab>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import { commonMixins } from '../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
import { contractMixins } from "../mixins/contractMixins";
import EvClaimTabVue from "@/components/warrantyClaimTabs/EvClaimTab.vue";
import EvFailureTabVue from "@/components/warrantyClaimTabs/EvFailureTab.vue";
import EvLocationTabVue from "@/components/warrantyClaimTabs/EvLocationTab.vue";
import EvPartTab from "./warrantyClaimTabs/EvPartTab.vue";
import EvLaborTab from "./warrantyClaimTabs/EvLaborsTab.vue";
import EvOtherChargeTab from "./warrantyClaimTabs/EvOtherChargeTab";
import EvPaymentTab from "./warrantyClaimTabs/EvPaymentTab.vue";
import EvAttachmentTab from "./warrantyClaimTabs/EvAttachmentTab.vue";
import EvWarrantyClaimReview from "./warrantyClaimTabs/EvWarrantyClaimReview.vue";

Vue.component("loading-content", LoadingContent);
Vue.component("claim-tab", EvClaimTabVue);
Vue.component("failure-tab", EvFailureTabVue);
Vue.component("location-tab", EvLocationTabVue);
Vue.component("part-tab", EvPartTab);
Vue.component("labor-tab", EvLaborTab);
Vue.component("other-charge-tab", EvOtherChargeTab);
Vue.component("payment-tab", EvPaymentTab);
Vue.component("attachment-tab", EvAttachmentTab);
Vue.component("review-tab",EvWarrantyClaimReview);

export default {
  name: "EvWarrantyClaimFormTabs",
  components: {
    appFooter: () => import('@/components/Footer')
  },
  props: {
    // sendingTabData: {
    //   type: Object,
    //   required: false,
    //   default: undefined
    // },
    // sendingLineItemData: {
    //   type: Object,
    //   required: false,
    //   default: undefined
    // }
  },
  mixins: [commonMixins, contractMixins],
  data: () => ({
    permissions: [],
    role: '',
    claimTabData: null,
    failureTabData: null,
    partTabData: null,
    laborTabData: null,
    otherChargesTabData: null,
    locationTabData: null,
    paymentTabData: null,
    attachmentTabData: null,
    sendingTabData: null,
    sendingLineItemData: null,
    claimId: null,
    loading: false,
    loadAllDealers: false,
  }),
  watch: {

    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (const element of permissions) {
          if (element.name == 'add_user') {
            self.cantAccessPage = true;
          }
          if (element.name == 'ev_load_all_dealer_dropdown') {
              self.loadAllDealers = true;
          }
        }
      }
      this.$refs.claimTab.getDealerLoadData(self.loadAllDealers);
    },

    //if state value update after then change the city value also update that in thie module.
    state: function (state) {

      var self = this;

      if (self.state == null) {
        self.city = null;
        self.cityArr = [];
      }
    }
  },
  created: function () {

  },
  mounted: function () {
    var self = this;
    self.getPermissions();
    var path = window.location.pathname;
    var segments = path.split("/");


    var userObj = JSON.parse(localStorage.getItem("user_obj"));
    if (userObj != null) {
      if (userObj.roles.length > 0) {
        self.role = userObj.roles[0].name;
      }
    }

    setTimeout(function () {

      var navListItems = $('div.setup-panel div a'),
      allWells = $('.setup-content'),
      allNextBtn = $('.nextBtn');

      allWells.hide();

      navListItems.click(function (e) {
        e.preventDefault();
        var $target = $($(this).attr('href')),
          $item = $(this);


        if (!$item.hasClass('disabled')) {
          navListItems.removeClass('btn-primary').addClass('btn-tertiary');
          $item.removeClass('btn-tertiary').addClass('btn-primary');
          allWells.hide();
          $('.setup-content1').hide();
          $target.show();
          $target.find('input:eq(0)').focus();
        }
      });
    }, 1000);
  },
  methods: {
    gotoBackStep: function (flag) {
      var self = this;
      $('div.setup-panel div a[href="#' + flag + '"]').trigger('click');
    },
    gotoNextStep: function (flag) {
      var self = this;

      var error = false;
      var path = window.location.pathname;
      var segments = path.split("/");

      if (error != true) {
        $('.setup-y ').hide();
        var curStep = $(this).closest(".setup-content"),
          curStepBtn = curStep.attr("id"),
          nextStepWizard = $('div.setup-panel div a[href="#' + flag + '"]').parent().next().children("a");

        nextStepWizard.removeAttr('disabled').trigger('click');
      }
      //     if (result) {
      $('div.setup-panel div a.btn-primary').trigger('click');
      // }
      // });
    },
    handleClaimTabData(dataFromClaimTab) {
      var self = this;
      self.claimTabData = dataFromClaimTab;
      self.storeTabData("claim_tab");
    },
    handleFailureTabData(dataFromFailureTab) {
      var self = this;
      self.failureTabData = dataFromFailureTab;
      self.storeTabData("failure_tab");

    },
    handlePartTabData(dataFromPartTab) {
      var self = this;
      self.partTabData = dataFromPartTab;
      if(self.partTabData.attachmentRequired == true){
        this.$refs.attachmentTab.checkAttachmentRequired(true);
      }
      self.storeTabData("parts_tab");
    },
    handleLaborTabData(dataFromLaborTab) {
      var self = this;
      self.laborTabData = dataFromLaborTab;
      self.storeTabData("labor_tab");
    },
    handleOtherChargesTabData(dataFromOtherChargesTab) {
      var self = this;
      self.otherChargesTabData = dataFromOtherChargesTab;
      self.storeTabData("other_tab");
    },
    handleLocationTabData(dataFromLocationTab) {
      var self = this;
      self.locationTabData = dataFromLocationTab;
    },
    handlePaymentTabData(dataFromPaymentTab) {
      var self = this;
      self.paymentTabData = dataFromPaymentTab;
    },
    handleAttachmentTabData(dataFromAttachmentTab, flag) {
      var self = this;
      self.attachmentTabData = dataFromAttachmentTab;
      self.storeTabData("attachment_tab");
      if(flag !== "delete_attached"){
        this.$refs.reviewTab.loadClaimData(self.claimId);
      }
    },
    handleReviewTabData(dataFromReviewTab){
      var success = self.ValidateTabDataForSave();
      if (success) {
        self.emitDataToParent(flag);
      }
    },
    ValidateTabDataForSave() {
      var self = this;
      var success = true;

      if (self.claimTabData == null || self.failureTabData == null
        || self.partTabData == null || self.laborTabData == null
        || self.otherChargesTabData == null || self.locationTabData == null
        || self.paymentTabData == null || self.attachmentTabData == null) {
        success = false;
      }
      return success;
    },
    emitDataToParent(flag) {
      var self = this;
      const dataToSend = {
        claimTabData: self.claimTabData,
        failureTabData: self.failureTabData,
        partTabData: self.partTabData,
        laborTabData: self.laborTabData,
        otherChargesTabData: self.otherChargesTabData,
        locationTabData: self.locationTabData,
        paymentTabData: self.paymentTabData,
        attachmentTabData: self.attachmentTabData,
        claimId: self.claimId,
      };
      self.$emit("send-data-to-parent", dataToSend, flag);
    },
    updateTabData(newTabData, claimId, flag = null) {
      var self = this;
      self.sendingTabData = newTabData;
      if (typeof self.sendingTabData !== "undefined") {
        this.$refs.claimTab.getClaimData(self.sendingTabData.claimTab);
        this.$refs.failureTab.getFailureData(self.sendingTabData.failureTab);
        this.$refs.locationTab.getLocationData(self.sendingTabData.locationTab);
        this.$refs.otherChargeTab.getOtherChargeData(self.sendingTabData.otherChargeTab);
        this.$refs.partTab.getPartTotals(self.sendingTabData.partTabTotal);
        this.$refs.laborTab.getLaborTotals(self.sendingTabData.laborTabTotal);
        this.$refs.attachmentTab.getAttachments(self.sendingTabData.attachmentTab, claimId);
        if (flag === 'delete_attached') {
          self.gotoNextStepMixins('step-7');
        }
      }
    },
    updateLineItemData(newLineItemData) {
      var self = this;
      self.sendingLineItemData = newLineItemData;
      if (typeof self.sendingLineItemData !== "undefined" && self.sendingLineItemData != null) {
        this.$refs.partTab.getPartLineItems(self.sendingLineItemData.part_items);
        this.$refs.laborTab.getLaborLineItems(self.sendingLineItemData.labor_items);
      }
    },
    storeTabData(tab) {
      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");
      var claimId = "create_new";
      if (segments[3]) {
        claimId = segments[3];
      } else {
        if (self.claimId != null) {
          claimId = self.claimId;
        }
      }
      if (tab == "claim_tab") {
        var storeData = self.claimTabData;
      }
      else if (tab == "failure_tab") {
        var storeData = self.failureTabData;
      }
      else if (tab == "parts_tab") {
        var storeData = self.partTabData;
      }
      else if (tab == "labor_tab") {
        var storeData = self.laborTabData;
      }
      else if (tab == "other_tab") {
        var storeData = self.otherChargesTabData;
      }else if (tab == "attachment_tab"){
        var storeData = self.attachmentTabData;
      }
      self.$parent.loading = true;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/warranty-claim/store/tabData",
        type: "POST",
        data: {
          claim_id: claimId,
          tab: tab,
          storeData: storeData,
        },
        headers: {
          "Accept": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        dataType: "json",
        cors: true,
        success: function (data) {
          self.loading = false;
          self.$parent.loading = false;
          self.claimId = data.content.id;
          self.$refs.laborTab.getLaborRate(data.content.laborRate);
          self.$refs.otherChargeTab.getTravelHourRate(
            data.content.laborRate,
            data.content.distanceRate,
          );
          // if(self.claimId != null && !segments[3]){
          //   self.$router.push("/warranty-claim/edit/" + segments[2]);
          // }
        },
        error: function (jqXHR, exception) {
          self.$parent.loading = false;
          self.loading = false;
        },
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EvWarrantyClaimFormTabs.vue